import { useMonarchRule } from '../../MonarchRulesProvider';
import {
  GeoPricingResult,
  GeoPricingTestData,
  GeoPricingVariant,
  UseGeoPricingTestHookResult,
} from './types';

const CUSTOM_RULE_ID = 'checkoutGeoPricingTest';

const useGeoPricing: UseGeoPricingTestHookResult = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: GeoPricingTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value?.data) {
    return {
      isLoading,
    } as GeoPricingResult;
  }

  // Determine the variant based on the returned data
  const variant: GeoPricingVariant = value.data.isGeoPricingEnabled
    ? 'test'
    : 'control';
  return { isLoading: false, variant, data: value.data };
};

export default useGeoPricing;
